import { useUserProfileApi } from '@/api/users';
import { useWorkspacesService } from '@/services/workspaces';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApiError } from '../../api/useApi';
import { Page404 } from '../layout/Page404';

interface WorkspaceValidatorProps {
  children: React.ReactNode;
}

/**
 * Component that validates workspace existence and throws errors for React Router to catch
 * This component will throw an ApiError if the workspace doesn't exist
 */
export function WorkspaceValidator({ children }: WorkspaceValidatorProps) {
  const { workspaceUname } = useParams<{ workspaceUname: string }>();
  const [isValidating, setIsValidating] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const { workspaces } = useWorkspacesService();
  const { data: userProfile } = useUserProfileApi();

  useEffect(() => {
    if (!workspaceUname || !workspaces || !userProfile) {
      setIsValidating(false);
      return;
    }

    const workspace = workspaces?.find(
      workspace => workspace.uname === workspaceUname
    );

    if (userProfile.type === 'ditto') {
      setError(null);
      setIsValidating(false);
      return;
    }

    if (!workspace) {
      const apiError = new ApiError(
        404,
        `Workspace '${workspaceUname}' not found`,
        'Not Found',
        new Date().toISOString(),
        `/${workspaceUname}`
      );
      setError(apiError);
    } else {
      setError(null);
    }

    setIsValidating(false);
  }, [workspaces, workspaceUname]);

  if (error && !isValidating) {
    return <Page404 />;
  }

  return <>{children}</>;
}
